import { useState, useEffect } from "react";




const PutOnSale = ({ closeModal }) => {
    const [quantity, setQuantity] = useState('');
    const [price, setPrice] = useState('');

    useEffect(() => {
        document.body.style.overflowY = "hidden";
        return () => {
            document.body.style.overflowY = "scroll";
        };
    }, []);



    return (
        <div>
            <div className="modal-wrapper" onClick={closeModal}></div>
            <div className="modal-container">
                <div class="center">
                    <h1>Put On Sale</h1>
                    <form>
                        <div class="inputbox">
                            <input type="number" value={quantity} onChange={(e) => setQuantity(e.target.value)} required="required" id="quantity" name="quantity" />
                            <span>Quantity</span>
                        </div>
                        <div class="inputbox">
                            <input type="number" value={price} onChange={(e) => setPrice(e.target.value)} required="required" id="price" name="price" />
                            <span>Price</span>
                        </div>
                        <div class="inputbox">
                            <input type="button" value="Submit" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default PutOnSale;